   
import { useContext, useEffect, useState } from 'react';
import yourAdHere from '../../assets/ad-now.jpg';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';
import defaultUserProfile from '../../assets/defaultUserProfile.jpeg';


const RightSide = () => {

    const navigate = useNavigate();

    const { user, token, setToken, setUser,setShowLogin } = useContext(AppContext);

    const [suggestionsUsers , setSuggestionsUsers] = useState({});

    const [followingState, setFollowingState] = useState(false);

    const [followed , setFollowed] = useState(null);

    const [lastAdsVideo , setLastAdsVideo] = useState(null);
    const [lastPhotos , setLastPhotos] = useState(null);

    async function handleLogout(e){

        e.preventDefault();

        const response = await fetch('https://dashboard.tiktaka.com/api/logout', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,  
            },
        });

        const data = await response.json();

        console.log(data);
        console.log(response);
      

      if (response.ok) {
            alert("✅ تم تسجيل الخروج بنجاح!");
            setUser(null);
            setToken(null);
            
            localStorage.removeItem('token');
            
            setShowLogin(true); 

            // navigate('/login'); 

        } else {
            console.log('ERROR');
            console.log(data.message);
        }

    };

    async function getLastVideo(){

        const response = await fetch('https://dashboard.tiktaka.com/api/lastVideo', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'  
            },
        });

        
        const data = await response.json();

        
        console.log('test test');
        // console.log(data);
        // console.log(data.ads);
        setLastAdsVideo(data.ads);
        
        // console.log(suggestionsUsers);
        
    }
    async function getLastPhotos(){

        const response = await fetch('https://dashboard.tiktaka.com/api/getLastPhotos', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'  
            },
        });

        
        const data = await response.json();

        
        console.log('test pic');
        console.log(data);
        console.log(data.ads);
        setLastPhotos(data.ads);
        
        // console.log(suggestionsUsers);
        
    }

    function getEmbedUrl(url) {
        if (!url) return "";
        
        // لو الرابط من نوع youtu.be
        if (url.includes("youtu.be")) {
            const videoId = url.split("/").pop().split("?")[0];
            return `https://www.youtube.com/embed/${videoId}`;
        }

        // لو الرابط عادي من YouTube
        if (url.includes("watch?v=")) {
            const videoId = url.split("v=")[1].split("&")[0];
            return `https://www.youtube.com/embed/${videoId}`;
        }

        return url;
}


    async function getSuggestions(){

        const response = await fetch('https://dashboard.tiktaka.com/api/suggestionsUsers', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'  
            },
            body: JSON.stringify({auth_id: user && user.id})

        });

        
        const data = await response.json();

        
        console.log('12555555555');
        console.log(data.users);
        console.log(data);
        setSuggestionsUsers(data.users);
        
        // console.log(suggestionsUsers);
        
    }

    const followUser = async (followedId) => {

        const formDataToSend = {
            followed_id : followedId
        };

        setFollowed(followedId);

        try {
        
            const res = await fetch('https://dashboard.tiktaka.com/api/makeFollow', {

                    method: 'post',
                    headers: {
                        Authorization: `Bearer ${token}`,  
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'

                    },
                    body: JSON.stringify(formDataToSend)
            });

            const data = await res.json();

            if(res.status === 401){
                setShowLogin(true); 
                // navigate('/login');
            }
            console.log('Followed', data);
        } catch (err) {
            console.error(err);
        }
    };

    const unfollowUser = async (followedId) => {

        const formDataToSend = {
            followed_id : followedId
        };

        setFollowed(followedId);

        try {
        
            const res = await fetch('https://dashboard.tiktaka.com/api/makeUnfollow', {

                    method: 'post',
                    headers: {
                        Authorization: `Bearer ${token}`,  
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'

                    },
                    body: JSON.stringify(formDataToSend)
            });

            const data = await res.json();
            if(res.status === 401){
                navigate('/login');
            }
            console.log('Unfollowed', data);
        } catch (err) {
            console.error(err);
        }
        };

    const handleFollowToggle = async (e, followedId) => {

        e.preventDefault();

        const isFollowing = followingState[followedId];


        if (isFollowing) {
            await unfollowUser(followedId);

        } else {
            await followUser(followedId);
        }

          setFollowingState(prev => ({
                ...prev,
                [followedId]: !isFollowing
            }));

        // const formDataToSend = {
        //     followed_id : followedId
        // };

        // setFollowed(followedId);


        // const response = await fetch('https://dashboard.tiktaka.com/api/makeFollow', {

        //     method: 'post',
        //     headers: {
        //         Authorization: `Bearer ${token}`,  
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json'

        //     },
        //     body: JSON.stringify(formDataToSend)
        // })



        // const data = await response.json();

        // console.log('====================================');
        // console.log(data);
        // console.log('====================================');

    }

    useEffect(()=>{
        getSuggestions();
        getLastVideo();
        getLastPhotos();
    }, [followed,user])



        

return (
    <div className='rightSide'>
        <div className='rightSideHome'>

            <div className='topProfileRight'>
                <div className='leftRightProfile'>

                <Link to={`/profile/${user?.hashed_id}/${user?.username}`} className='imgDIvRightSide'>

                    <img className='imgDIvRightSideProfile' src={ user &&
                            user.avatar != null
                              ? `https://dashboard.tiktaka.com/${user.avatar}`
                              : defaultUserProfile
                          } alt='none' />
                </Link>
                </div>
                <div className='userNameBlock'>
                    {/* <Link to={`/profile/${user?.hashed_id}`} > */}
                        <div className='userNameRightSide'>{user ? user.name :'guest'}</div>
                        <div className='userFullName'>{user ? user.username :'username'}</div>
                    {/* </Link> */}
                </div>


                    {
                        user ? 
                        <button className='logoutBtn' onClick={handleLogout}>
                            <div  onClick={handleLogout}>Logout</div>
                        </button>
                        :
                        <button className='logoutBtn' onClick={() => setShowLogin(true)}>
                            <div>Login</div>
                        </button>
                        

                    }

            </div>



            
            <div className='bottomRightSide'>
                <div className='suggestedBlock'>
                    
                    <div className='suggestedForYou'>Suggested For You</div>
                </div>

                {/* ///////////////////////// */}

                {/* Start Suggested Profiles */}

                <div className='followBlockSideBlock'>

            { suggestionsUsers.length > 0 ?  suggestionsUsers.map(suggestionsUser => (

                <div className='topSuggestedRight'>
                    <div className='suggestedProfiles'>

                    <Link to={`/profile/${suggestionsUser?.hashed_id}/${suggestionsUser?.username}`} >

                        <div className='imgDIvSuggestedSide'>
                            <img className='imgDIvSuggestedProfile' width={45} height={45} src={ suggestionsUser.avatar != null ? `https://dashboard.tiktaka.com/${suggestionsUser.avatar}` : defaultUserProfile } alt='none' />
                        </div>

                    </Link>

                    </div>
                    <div className='userNameBlock'>
                        <div className='userNameRightSide'>{suggestionsUser.name}</div>
                        <div className='userFullName'>{suggestionsUser.username}</div>
                    </div>


                    <form onSubmit={e=>handleFollowToggle(e, suggestionsUser.id)}>
                        <button type="submit" className='followBtn'>
                        {followingState[suggestionsUser.id] ? 'Unfollow' : 'Follow'}

                        </button>
                    </form>
                    {/* <div className='followBtn'>Follow</div> */}
                </div>

            ) ) : 'No Suggestions ' }



                </div>

            {/* ///////////////////////// */}

    {/* <AllPopups /> */}


            {/* End Suggested Profiles */}

            {/* Ad Banner Start Here */}



            {/* <div className='yourAdHere'>
                <img className='adNow' src={yourAdHere} alt='your ad here' />
            </div>
            <div className='yourAdHere'>
                <img className='adNow' src={yourAdHere} alt='your ad here' />
            </div> */}


                {lastPhotos && lastPhotos.length > 0 ? (
                lastPhotos.map((ad) => (
                    <div key={ad.id} className='yourAdHere'>
                    <img 
                        className='adNow' 
                        src={`https://dashboard.tiktaka.com/${ad.file}`} // غيّر `file_path` لاسم العمود الصح عندك
                        alt='ad' 
                    />
                    </div>
                ))
                ) : (
                <>
                    <div className='yourAdHere'>
                    <img className='adNow' src={yourAdHere} alt='your ad here' />
                    </div>
                    <div className='yourAdHere'>
                    <img className='adNow' src={yourAdHere} alt='your ad here' />
                    </div>
                </>
                )}


            {/* Ad Banner End Here */}

            {/* Sponsored Video Start Here */}


            <div className='sponsoredVideoEmbed'>
                <iframe 
                width="300" 
                height="300" 
                src={getEmbedUrl(lastAdsVideo?.youtube_link)}
                // src="https://www.youtube.com/embed/0gp1rP0oLks?" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; 
                autoplay; 
                clipboard-write; 
                encrypted-media; 
                gyroscope; 
                picture-in-picture; 
                web-share" allowFullScreen>
                </iframe>
            </div>

            {/* Sponsored Video End Here */}

            
            <div className='rightsReserved'>All rights reserved to TikTaka.com</div>


            
                </div>
        </div>
    </div>
);

};

export default RightSide;

   
